import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackClientEvent } from 'analytics/analytics'

export type ExperienceSuggestedSearchBucket = 'local' | 'worldwide'

const CATEGORY = 'experiences_offer_page_suggested_searches'

function getSubject(bucket: ExperienceSuggestedSearchBucket, countryCode?: string) {
  return `${bucket}_${countryCode ?? 'unknown'}`
}

function getListContext(bucket: ExperienceSuggestedSearchBucket, listInstance: string, itemPosition: number) {
  return comluxgroup.createListItem_1_0_0({
    listName: `${CATEGORY}_${bucket}`,
    listInstance,
    itemPosition,
  })
}

export function trackExperienceSuggestedSearchesImpression(bucket: ExperienceSuggestedSearchBucket, countryCode: string | undefined, listInstance: string) {
  trackClientEvent({
    category: CATEGORY,
    type: 'nonInteraction',
    subject: getSubject(bucket, countryCode),
    action: 'impression',
    context: [getListContext(bucket, listInstance, 1)],
  })
}

export function trackExperienceSuggestedSearchClick(bucket: ExperienceSuggestedSearchBucket, countryCode: string | undefined, listInstance: string, position: number) {
  trackClientEvent({
    category: CATEGORY,
    type: 'interaction',
    subject: getSubject(bucket, countryCode),
    action: 'chip_clicked',
    context: [getListContext(bucket, listInstance, position)],
  })
}
